jQuery(function($) {

    // Menu responsive
    $(".menu-toggle").on("click",function(e){
        e.preventDefault();
        $("#main-menu").slideToggle();
    })

    // Open speaker information in popup
    $('a.popup-speaker').magnificPopup({
        type: 'ajax',
        mainClass: 'mfp-fade'
    });

    // Program day selector
    if($('.program').length) {

        var hash = $(location).attr('hash');
        if(hash) {
            $('.program:not('+hash+')').hide();
            $('.program-menu a.active').removeClass('active')
            $('.program-menu a[href="'+hash+'"').addClass('active');
            $(hash).addClass('active');
        } else {
            $('#day2,#day3').hide();
            $('#day1').addClass('active');
        }

        $('.program-menu a').on("click",function(e){
            e.preventDefault();
            if(!$(this).hasClass('active')) {
                $('.program-menu a.active').removeClass('active')
                $(this).addClass('active');
                let day = $(this).attr("href");
                $('.program.active').fadeOut(300,function(){
                    $(this).removeClass('active')
                    $(day).addClass('active').fadeIn(300,function(){
                        history.pushState({}, '', day);
                    });
                    
                });
                
            }
            return false;
        })

    }

    $(".read-more").on('click',function(e){
        e.preventDefault();
        $(this).parent().next('.bio-extra').slideToggle();
    });

});